document.addEventListener('DOMContentLoaded', function () {
  const form = $('.supportcontact-form-rightcon');
  const nameInput = form.find('.support_contfm_name');
  const emailInput = form.find('.support_contfm_email');
  const msgInput = form.find('.support_contfm_msg');
  const submitBtn = form.find('.submit_support');

  // 初始禁用按钮
  submitBtn.prop('disabled', true);

  // 验证单个字段
  function validateField($field) {
    const val = $field.val().trim();

    if ($field.is(nameInput)) {
      if (val === '') {
        $field.addClass('errmsg').siblings('.error_namemsg').show();
        $field.siblings('.error_namemsg_format').hide();
      } else if (!/^[A-Za-z\s]+$/.test(val)) {
        $field.addClass('errmsg').siblings('.error_namemsg').hide();
        $field.siblings('.error_namemsg_format').show();
      } else {
        $field.removeClass('errmsg').siblings('.error_namemsg, .error_namemsg_format').hide();
      }
    }

    else if ($field.is(emailInput)) {
      if (val === '') {
        $field.addClass('errmsg').siblings('.error_emailmsg').show();
        $field.siblings('.error_emailmsg_format').hide();
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        $field.addClass('errmsg').siblings('.error_emailmsg').hide();
        $field.siblings('.error_emailmsg_format').show();
      } else {
        $field.removeClass('errmsg').siblings('.error_emailmsg, .error_emailmsg_format').hide();
      }
    }

    else if ($field.is(msgInput)) {
      if (val === '') {
        $field.addClass('errmsg').siblings('.error_backmsg_format').show();
      } else {
        $field.removeClass('errmsg').siblings('.error_backmsg, .error_backmsg_format').hide();
      }
    }
  }

  // 控制按钮状态（只有都有效才启用）
  function updateSubmitButton() {
    const nameVal = nameInput.val().trim();
    const emailVal = emailInput.val().trim();
    const msgVal = msgInput.val().trim();

    const valid =
      /^[A-Za-z\s]+$/.test(nameVal) &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal) &&
      msgVal !== '';

    submitBtn.prop('disabled', !valid);
  }

  // filled class逻辑 + 单字段验证
  form.find('input, textarea').on('input', function () {
    const $this = $(this);
    if ($this.val().trim() !== '') {
      $this.addClass('filled');
    } else {
      $this.removeClass('filled');
    }

    validateField($this); // ✅ 只验证当前字段
    updateSubmitButton(); // ✅ 每次都重新判断按钮状态
  });

  // 失焦时也只验证当前字段
  form.find('input, textarea').on('blur', function () {
    validateField($(this));
    updateSubmitButton();
  });

  // hover 样式（可按你的CSS控制）
  form.find('input, textarea').hover(
    function () {
      $(this).addClass('hover');
    },
    function () {
      $(this).removeClass('hover');
    }
  );
});
